"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _constant2 = require("./constant");
var _default = {
  PropTypes: {
    width: _propTypes.default.string,
    height: _propTypes.default.string,
    borderRadius: _propTypes.default.string,
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    buttonTextTop: _propTypes.default.string,
    buttonTextBottom: _propTypes.default.string,
    handleMouseEnter: _propTypes.default.func,
    handleMouseLeave: _propTypes.default.func,
    customProperties: _propTypes.default.object,
    buttonColor: _propTypes.default.string,
    isShowIcon: _propTypes.default.bool,
    shimmerColor: _propTypes.default.string
  },
  DefaultProps: {
    width: _constant2.DEFAULT_SHIMMER_BUTTON.WIDTH,
    height: _constant2.DEFAULT_SHIMMER_BUTTON.HEIGHT,
    borderRadius: _constant2.DEFAULT_SHIMMER_BUTTON.BORDER_RADIUS,
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    buttonTextTop: _constant2.DEFAULT_SHIMMER_BUTTON.BUTTON_TEXT_TOP,
    buttonTextBottom: _constant2.DEFAULT_SHIMMER_BUTTON.BUTTON_TEXT_BOTTOM,
    handleMouseEnter: _constant2.DEFAULT_SHIMMER_BUTTON.HANDLE_MOUSE_ENTER,
    handleMouseLeave: _constant2.DEFAULT_SHIMMER_BUTTON.HANDLE_MOUSE_LEAVE,
    buttonColor: _constant2.DEFAULT_SHIMMER_BUTTON.BUTTON_COLOR,
    customProperties: _constant2.DEFAULT_SHIMMER_BUTTON.CUSTOM_PROPERTIES,
    isShowIcon: _constant2.DEFAULT_SHIMMER_BUTTON.IS_SHOW_ICON,
    shimmerColor: _constant2.DEFAULT_SHIMMER_BUTTON.SHIMMER_COLOR
  }
};
exports.default = _default;